import React from "react";
import { Users, Armchair, Footprints, ChevronRight } from "lucide-react";
import { C, FONT, namaKota } from "../kota/ui";
import { Sheet, Empty, chipStyle } from "../kota/Sheet";
import { AvatarCanvas } from "./AvatarCanvas";

// Daftar warga yang sedang berada di alun-alun — ketuk baris untuk melihat kartunya & kamera melompat ke posisinya
// (berguna saat pemain berada di luar layar). Pemain sendiri ditampilkan paling atas tanpa aksi.
export function OnlineSheet({ players, meId, onPilih, onClose }) {
  const daftar = [...players.values()].sort((a, b) => (a.id === meId ? -1 : b.id === meId ? 1 : (a.username || a.nama).localeCompare(b.username || b.nama)));
  return (
    <Sheet testid="online-sheet" title="Warga di alun-alun" sub={`${daftar.length} orang sedang di sini`} icon={Users} onClose={onClose}>
      {daftar.length === 0 ? <Empty icon={Users} text="Belum ada yang datang. Jadilah yang pertama!" testid="online-kosong" /> : (
        <div style={{ display: "flex", flexDirection: "column", gap: 6, paddingBottom: 8 }}>
          {daftar.map(p => {
            const saya = p.id === meId;
            return (
              <button key={p.id} data-testid={`online-item-${p.id}`} disabled={saya} onClick={() => onPilih(p)}
                style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 10px 8px 8px", borderRadius: 18, border: `1px solid ${C.line}`, background: saya ? C.blueSoft : "#fff", textAlign: "left", cursor: saya ? "default" : "pointer", fontFamily: FONT, color: C.ink, width: "100%" }}>
                <span style={{ width: 46, height: 46, borderRadius: 14, background: C.cream, display: "grid", placeItems: "center", overflow: "hidden", flex: "none" }}><AvatarCanvas av={p.avatar} size={54} anim={false} /></span>
                <span style={{ flex: 1, minWidth: 0, lineHeight: 1.25 }}>
                  <b style={{ fontSize: 14, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>@{p.username || p.nama}{saya && <span style={{ color: C.blue, fontWeight: 700 }}> (kamu)</span>}</b>
                  <span style={{ fontSize: 11.5, color: C.sub, fontWeight: 600, display: "flex", alignItems: "center", gap: 6, marginTop: 3 }}>
                    <span style={chipStyle(p.duduk ? "amber" : "green")}>{p.duduk ? <><Armchair size={10} style={{ verticalAlign: -1 }} /> duduk</> : <><Footprints size={10} style={{ verticalAlign: -1 }} /> jalan-jalan</>}</span>
                    <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Lv {p.lv} · {namaKota(p.kota)}</span>
                  </span>
                </span>
                {!saya && <ChevronRight size={16} color={C.sub} />}
              </button>
            );
          })}
        </div>
      )}
    </Sheet>
  );
}
